import styled from 'styled-components';
import media from '../../../mediaqueries/media';
const MobileCallHistoryWrapper = styled.div`
height:100%;
.pl-15{
    padding-left:15px !important;
}
.pr-15{
    padding-right:15px !important;
}
.pr-30{
    padding-right: 30px !important;
}
.callHistory {
    padding:20px 0;
    ${media.tablet`
    background: #f7f7f9;
        `}
    .tableFilters {
        width: 100%;
        margin: auto;
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;
        .entriesSelector {
            background: #fff;
            border-radius: 4px;
            padding: 5px 15px;
            display: -webkit-box;
            display: -moz-box;
            display: -ms-flexbox;
            display: -webkit-flex;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            label {
                font-family: 'Open Sans',sans-serif;
                font-size: 13px;
                font-weight: 700;
                color: #1f337a;
                text-transform: uppercase;
                display: block;
                margin-right: 10px;
            }
            .selector-wrapper {
                position: relative;
                select {
                    min-width: 140px;
                    font-size: 13px;
                    font-weight: 500;
                    color: #333e61;
                    padding: 0 10px;
                    -webkit-appearance: none;
                    -moz-appearance: none;
                    -webkit-appearance: none;
                    -moz-appearance: none;
                    appearance: none;
                    border: none;
                    padding: 5px;
                    background: transparent;
                    position: relative;
                    z-index: 2;
                    &:focus {
                        outline: none;
                    }
                }
                &:after {
                    content: '';
                    position: absolute;
                    width: 0;
                    height: 0;
                    border-color: #333e61 transparent transparent transparent;
                    border-style: solid;
                    border-width: 4px 4px 0px 4px;
                    top: 14px;
                    right: 0px;
                    z-index: 1;
                }
            }
        }
        .entriesLegends {
            background: #fff;
            padding: 10px;
            border-radius: 4px;
            ul {
                margin: 0;
                padding: 0;
                list-style: none;
                display: -webkit-box;
                display: -moz-box;
                display: -ms-flexbox;
                display: -webkit-flex;
                display: flex;
                flex-direction: row;
                align-items: center;
                li {
                    display: -webkit-box;
                    display: -moz-box;
                    display: -ms-flexbox;
                    display: -webkit-flex;
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    padding: 0 10px 0;
                    .legend-symbol {
                        width: 10px;
                        height: 10px;
                        border-radius: 10px;
                        display: block;
                        margin-right: 5px;
                        &.approved {
                            background: #70c82b;
                        }
                        &.pending {
                            background: #5594da;
                        }
                        &.declined {
                            background: #f2cc50;
                        }
                    }
                    >h2 {
                        font-family: 'Open Sans',sans-serif;
                        color: #1b2751;
                        text-transform: capitalize;
                        font-size: 13px;
                        font-weight: normal;
                        font-style: italic;
                    }
                }
            }
        }
        .searchEntries {
            position: relative;
            // min-width: 470px;
            width:100%;
            >label {
                font-family: 'Open Sans',sans-serif;
                color: #344177;
                text-transform: uppercase;
                font-size: 14px;
                font-weight: 600;
                padding: 0 0 10px;
                display: block;
            }
            >input[type="text"] {
                font-family: 'Open Sans',sans-serif;
                font-weight: 400;
                background: #f7f7f9;
                line-height: normal;
                width: 100%;
                padding: 12px 15px;
                border: 1px solid #b2b9d6;
                border-radius: 10px;
                &:focus {
                    outline: none;
                    box-shadow: none;
                }
                &::-webkit-input-placeholder {
                    color: #1f337a;
                    font-style: italic;
                    font-size: 12px;
                }
                &:-moz-placeholder {
                    color: #1f337a;
                    font-style: italic;
                    font-size: 12px;
                }
                &::-moz-placeholder {
                    color: #1f337a;
                    font-style: italic;
                    font-size: 12px;
                }
                &:-ms-input-placeholder {
                    color: #1f337a;
                    font-style: italic;
                    font-size: 12px;
                }
            }
            .search_icon {
                position: absolute;
                right: 15px;
                top: 50%;
                transform: translateY(-50%);
                >img {
                    vertical-align: top;
                }
            }
        }
    }
    .tableFooter {
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-align-items: center;
        -webkit-box-align: center;
        -webkit-flex-align: center;
        align-items: center;
        justify-content: space-between;
        background: #fff;
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        padding: 10px;
        height: 60px;
        border-top: 2px solid #ececec;
        z-index: 99;
        .nextPage {
            background: #1f337a;
            color: #fff;
            padding: 5px 15px;
            border-radius: 4px;
            text-transform: uppercase;
            font-weight: 700;
            font-size: 12px;
            border: none;
            cursor: pointer;
            padding: 7px 30px;
            &:focus {
                outline: none;
            }
        }
        .releaseBtn {
            background: #70c82b;
            color: #fff;
            width: 180px;
            height: 37px;
            // padding: 5px 25px;
            border-radius: 21px;
            text-transform: uppercase;
            font-weight: 800;
            font-size: 13px;
            border: none;
            cursor: pointer;
            padding: 7px 30px;
            &:focus {
                outline: none;
            }
        }
        .paginationCustom {
            .ant-pagination-item-link {
                font-size: 11px;
                border-color: #1f337a;
                color: #1f337a;
            }
            .ant-pagination-prev {
                border-color: #4f62a5;
                min-width: 25px;
                height: 25px;
                line-height: 25px;
            }
            .ant-pagination-next {
                border-color: #4f62a5;
                min-width: 25px;
                height: 25px;
                line-height: 25px;
            }
            .ant-pagination-disabled {
                .ant-pagination-item-link {
                    border-color: #9ed4e1;
                    color: #9ed4e1;
                }
            }
            .ant-pagination-item {
                border-color: #1f337a;
                min-width: 25px;
                height: 25px;
                line-height: 25px;
                >a {
                    color: #1f337a;
                    font-size: 12px;
                }
            }
            .ant-pagination-item-active {
                background: #1f337a;
                >a {
                    color: #ffffff;
                }
            }
        }
    }
    .dataTable {
        padding-bottom: 30px;
        margin-top: 30px !important;
        .action-button {
            background: #ffffff;
            width: 25px;
            height: 25px;
            border: none;
            border-radius: 5px;
            display: -webkit-box;
            display: -moz-box;
            display: -ms-flexbox;
            display: -webkit-flex;
            display: flex;
            -webkit-align-items: center;
            -webkit-box-align: center;
            -webkit-flex-align: center;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            &:focus {
                outline: none;
            }
        }
        table, tr, thead, td {
            font-family: 'Open Sans',sans-serif !important;
        }
        td {
            font-family: 'Open Sans',sans-serif !important;
            color: #000000;
            font-size: 11px;
            font-weight: normal;
            border-bottom: 1px solid #b2b9d6;
        }
        .ant-table-column-title {
            font-family: 'Open Sans',sans-serif !important;
            color: #000000;
            font-size: 11px;
            text-transform: uppercase;
            font-weight: bold;
        }
        .ant-table-row {
            border: 2px solid #000;
        }
        .ant-table-row:nth-child(odd) {
            background: #f7f7f9;
        }
        .ant-table-row:nth-child(even) {
            background: #f7f7f9;
        }
        .ant-table-pagination.ant-pagination {
            float: left;
        }
        .ant-table-thead > tr > th {
            background: #f7f7f9 !important;
            font-weight: 700;
            font-size:12px;
            border-bottom: 1px solid #b2b9d6;
            padding: 2px 16px;
        }
    }






    .callHistory-box{
        margin-top:2rem;
        .card-panel{
            position: relative;
            display: flex;
            flex-direction: column;
            min-width: 0;
            padding:0;
            word-wrap: break-word;
            background-color: #fff;
            // background-clip: border-box;
            // border: 1px solid #b2b9d6;
            // border-radius: 10px;
            .col{
                >h1{
                    font-family:"open sans", sans-serif;
                    color:#32407b;
                    font-size: 17px;
                    font-weight: bold;
                    font-stretch: normal;
                    font-style: normal;
                    text-align: left;
                    margin:0;
                    padding:0 0 7px;
                    ${media.tablet`
                    font-size: 13px;
                        `}
                }
                .duration{
                    display: flex;
                    >span{
                        margin:0 5px;
                    }
                    >h2{
                        font-family:"open sans", sans-serif;
                        color:#08b2e3;
                        font-size: 14px;
                        font-weight: normal;
                        font-stretch: normal;
                        font-style: normal;
                        margin:0;
                        padding:0;
                        line-height: normal;
                    }
                }
                >h3{
                    font-family:"open sans", sans-serif;
                    color:#32407b;
                    font-size: 15px;
                    font-weight: normal;
                    font-stretch: normal;
                    font-style: normal;
                    margin:0;
                    padding:0 0 7px;
                }
                .totalDuration{
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                    >h4{
                        font-family:"open sans", sans-serif;
                        color:#08b2e3;
                        font-size: 14px;
                        font-weight: normal;
                        font-stretch: normal;
                        font-style: normal;
                        text-align: left;
                        margin: 0;
                        padding: 0;
                    }
                    >span{
                        margin-right:5px;
                    }
                }
            }
            .listItem{
                cursor:pointer;
                padding:1.25rem 0;
                position:relative;
               
                &:after{
                    content: '';
                    position: absolute;
                    background: #dee1ee;
                    height: 1px;
                    left: 1rem;
                    right: 1rem;
                    bottom: 0;
                }
                &.no-border{
                    cursor:auto;
                    &:after{
                        content:none;
                    }
                }
                &:last-child{
                    &:after{
                        content:none;
                    }
                }
                &.active{
                    background:rgba(8,178,227,0.1);
                }
                &.rightarrow{
                    background-image:url('/images/right-arrow@2x.png');
                    background-repeat: no-repeat;
                    background-position: 97% center;
                    background-size:7px;
                }
            }

            footer{
                padding:1rem 0;
                border-top:1px solid #dee1ee;
                position:relative;
                align-items: center;
                justify-content: center;
                .history-loader{
                    // position: absolute;
                    // bottom: 20px;
                    text-align: center;
                    right: 0;
                    left: 0;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    .loader-icon{
                        border: 3px solid #f4f4f4;
                        border-radius: 50%;
                        border-top: 3px solid #344177;
                        width: 35px;
                        height: 35px;
                        -webkit-animation: spin 2s linear infinite; /* Safari */
                        animation: spin 2s linear infinite;
                    }
                    @-webkit-keyframes spin {
                        0% { -webkit-transform: rotate(0deg); }
                        100% { -webkit-transform: rotate(360deg); }
                      }
                      
                      @keyframes spin {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(360deg); }
                      }
                }
                
                .load-more-btn{
                        font-family:"open sans", sans-serif;
                        cursor: pointer;
                        max-width: 140px;
                        min-width: 140px;
                        font-size: 1em;
                        border: 1px solid #4eb0de;
                        border-radius: 10px;
                        display: block;
                        text-transform: uppercase;
                        text-align: center;
                        color: #4eb0de;
                        font-weight: 700;
                        background: #ffffff;
                        padding: 10px 20px;
                        margin:0 auto;
                }
            }
        }
        .callhistory-summary{
            // right: 5px;
            // left: 5px;
            
            bottom: 0;
            top: 0;
            min-height: 400px;
            max-height: 300px;
            position: absolute;
            right: 0;
            left: 0;
            &.autobox{
                min-height:110px;
                >h1{
                    font-family:"open sans", sans-serif;
                    color:#b2b9d5;
                    font-size: 14px;
                    font-weight: normal;
                    text-align: center;
                    padding: 45px 0 0;
                    margin: 0;
                }
            }
            .scrollable-content{

            }
        }
        }
        .callhistory-detail{
            // right: 5px;
            // left: 5px;
            
            bottom: 0;
            top: 0;
            min-height: 400px;
            max-height: 400px;
            position: absolute !important;
            right: 0;
            left: 0;
            .listItem{
                padding:1.25rem;
                .col{
                    h5{
                        font-family:"open sans", sans-serif;
                        color:#b2b9d5;
                        font-size: 14px;
                        font-weight: normal;
                        font-stretch: normal;
                        font-style: normal;
                        text-align: left;
                        margin: 0;
                        padding: 1rem 0 0;
                    }
                    .right-title{
                        display:flex;
                    }
                    >h1{
                        padding:0;
                    }
                }
               
            }
            .back-btn{
                display: inline-flex;
                align-items: center;
                margin: 0 0 10px 15px;
                >h2{
                    margin:0;
                    padding:0 5px 0;
                    font-family:"open sans", sans-serif;
                    color:#32407b;
                    font-size: 16px;
                    text-transform: uppercase;
                    font-weight:700;
                }
            }
        }
    }
}


`;


export default (MobileCallHistoryWrapper);